export const ValidationPatterns: { [key: string]: string } = {
    date: '^((0?[1-9]|1[012])[/](0?[1-9]|[12][0-9]|3[01])[/](19|20)?[0-9]{2})*$'
};
